class ServiceTimeUpdateLocationsCollection extends App.Collections.BaseCollection {
    url = 'ServiceTimeUpdLocation';
    model = App.Models.ServiceTimeUpdateLocations;
}

App.Collections.ServiceTimeUpdateLocations = ServiceTimeUpdateLocationsCollection;

class ServiceTimeUpdateServiceTimeTypesCollection extends App.Collections.BaseCollection {
    url = 'ServiceTimeUpdServiceTimeType';
    model = App.Models.ServiceTimeUpdateServiceTimeTypes;
}

App.Collections.ServiceTimeUpdateServiceTimeTypes = ServiceTimeUpdateServiceTimeTypesCollection;
